<template>
    <div align="center">
        <div>
            <div class="commonContent" :style="'height:' + tabHeight + 'px'" ref="commonContentRef">
                <div style="margin: 15px;">
                    <span>报修单信息</span>
                </div>
                <el-form inline class="el-form el-form--inline" label-width="150px" label-position="right">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="报修单号：">
                                <el-input v-model="form.repaircode" style="width: 250px" disabled></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="故障类型：">
                                <el-input v-model="form.faulttypeName" style="width: 250px" disabled></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="状态：">
                                <el-input v-model="form.statusName" style="width: 250px" disabled></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="维修状态：">
                                <el-input v-model="form.ostatusName" style="width: 250px" disabled></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="联系人：">
                                <el-input v-model="form.studentname" style="width: 250px" disabled></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="联系电话：">
                                <el-input v-model="form.telephone" style="width: 250px" disabled></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="报修时间：">
                                <el-input v-model="form.createdate" style="width: 250px" disabled></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="预约时间：">
                                <el-input v-model="form.repairtime" style="width: 250px" disabled></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="派单人：">
                                <el-input v-model="form.distributennel" style="width: 250px" disabled></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="派单时间：">
                                <el-input v-model="form.distributime" style="width: 250px" disabled></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="接单人：">
                                <el-input v-model="form.repersonnel" style="width: 250px" disabled></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="接单时间：">
                                <el-input v-model="form.receivingtime" style="width: 250px" disabled></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="学生校区：">
                                <el-input v-model="form.regionName" style="width: 250px" disabled></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="完成时间：">
                                <el-input v-model="form.completetime" style="width: 250px" disabled></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="区域：">
                                <el-input v-model="form.bulidingName" style="width: 250px" disabled></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="地址：">
                                <el-input v-model="form.detailedaddress" style="width: 500px" disabled></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="故障描述：">
                                <el-input type="textarea" :rows="6" placeholder="请输入内容" v-model="form.faultdescription" style="width: 500px" disabled> </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row v-if="images.length > 0">
                        <el-col :span="24">
                            <el-form-item label="图片：">
                                <div v-for="(o, i) in images" :key="i">
                                    <el-image style="width: 500px;" :src="showImage(o)"></el-image>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row v-if="videoList.length > 0">
                        <el-col :span="24">
                            <el-form-item label="视频：">
                                <div v-for="(item,index) in videoList" :key="index">
                                    <video controls style="width: 500px; height: 400px" :src="item.src"></video>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="18" align="center" style="margin-top: 10px">
                            <el-button type="primary" plain size="90" @click="close">返回</el-button>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import TabResize from "@/utils/TabResizeEx.js";
import SettingApi from "@/api/setting.js";
import FaultApi from "@/api/fault.js";

export default {
    mixins: [TabResize],
    components: {},

    data () {
        return {
            form: {
                repaircode: "",
                faulttypeName: "",
                statusName: "",
                ostatusName: "",
                studentname: "",
                telephone: "",
                createdate: "",
                repairtime: "",
                distributennel: "",
                distributime: "",
                repersonnel: "",
                receivingtime: "",
                regionName: "",
                bulidingName: "",
                detailedaddress: "",
                faultdescription: ""
            },
            images: [],
            loading: true,
            videoList: [] //视频
        };
    },
    mounted: function () {
        this.initData(this.$route.params.row.orderid);
    },
    methods: {
        initData (id) {
            FaultApi.getClass()
                .findOrderById(id)
                .then((resp) => {
                    if (this.$constant.BIZ_RESPONSE_CODE == resp.data.code) {
                        this.form = resp.data.data;

                        if (!this.form.ostatusName) {
                            this.form.ostatusName = "未派单";
                        }
                        this.uplodImage(this.form.orderid);
                        this.Uplodvideo(this.form.orderid);
                    } else {
                        this.$message.error(resp.data.msg);
                        this.loading = false;
                        return false;
                    }
                }).catch((err) => {
                    this.loading = false;
                    this.$message.error(err);
                    return false;
                });
        },

        uplodImage (id) {
            let recordId = id;

            FaultApi.getClass()
                .getFiles("9981", id)
                .then((resp) => {
                    if (this.$constant.BIZ_RESPONSE_CODE == resp.data.code) {
                        let data = resp.data.data;
                        let pictures = [];

                        for (var i = 0; i < data.length; i++) {
                            pictures.push(data[i].id);
                        }
                        this.loadImage(pictures);
                    } else {
                        this.$message.error(resp.data.msg);
                        this.loading = false;
                        return false;
                    }
                }).catch((err) => {
                    this.loading = false;
                    this.$message.error(err);
                    return false;
                });
        },

        Uplodvideo (id) {
            let _this = this;

            FaultApi.getClass()
                .getFiles("998102", id)
                .then((resp) => {
                    if (this.$constant.BIZ_RESPONSE_CODE == resp.data.code) {
                        let data = resp.data.data;
                        for (let j of data) {
                            this.videoList.unshift({
                                id: j.id,
                                src: this.$constant.LOAD_FILE(_this, j.id)
                            });
                        }
                    } else {
                        this.$message.error(resp.data.msg);
                        this.loading = false;
                        return false;
                    }
                }).catch((err) => {
                    this.loading = false;
                    this.$message.error(err);
                    return false;
                });
        },

        loadImage (userIcons) {
            let imgIds = userIcons;
            for (var i = 0; i < imgIds.length; i++) {
                let item = imgIds[i];
                FaultApi.getClass()
                    .downloadFile(item)
                    .then((resp) => {
                        let data = resp.data;
                        if (data != null) {
                            this.images.push(resp.data);
                        } else {
                            this.images.push({
                                url: "",
                            });
                        }
                    }).catch((err) => {
                        return false;
                    });
            }
        },
        showImage (o) {
            return URL.createObjectURL(o);
        },
        close () {
            this.$router.go(-1);
        }
    }
};
</script>

<style lang="scss" scoped>
.commonContent {
    width: 80%;
    overflow-y: auto;
}
.commonContent .el-form .el-form-item {
    display: -webkit-box;
}
.imgdiv {
    display: flex;
    border: 1px solid #000;
}
</style>